import Vue from 'vue';
import Router from 'vue-router';
import Index from '@/views/Index';
import World from '@/views/World';
import City from '@/views/City';
import About from '@/views/About';
import ErrorPage from '@/views/404';
import AddFace from '@/views/AddFace';
import LoadingError from '@/views/LoadingError';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Index,
    },
    {
      path: '/about',
      name: 'about',
      component: About,
    },
    {
      path: '/add-your-face',
      name: 'addFace',
      component: AddFace,
    },
    {
      path: '/world',
      name: 'world',
      component: World,
    },
    {
      path: '/:city(tokyo|porto|berlin|milan|copenhagen)',
      name: 'city',
      component: City,
    },
    {
      path: '/loading-error',
      name: 'loading-error',
      component: LoadingError,
    },
    {
      path: '/*',
      name: 'ErrorPage',
      component: ErrorPage,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js